const ServiceRoomIcon = ({ width = 20 }) => (
  <svg width={width} height={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.6275 13.9337V16.0975H2.38V8.34H0V23.8575H2.38V20.3112H27.6275V24.1537H30V13.9312L27.6275 13.9337Z" fill="currentColor" />
    <path d="M10.8862 13.9562V13.9575C10.8862 14.6625 10.315 15.235 9.60875 15.235H4.74125C4.40243 15.235 4.07749 15.1004 3.83792 14.8608C3.59834 14.6213 3.46375 14.2963 3.46375 13.9575V13.955C3.46375 13.25 4.035 12.6775 4.74125 12.6775H9.60875C10.3137 12.6775 10.8862 13.2487 10.8862 13.955V13.9562ZM24.6787 8.955H21.7162V6H19.6162V8.95625H16.66V11.0563H19.615V14.0125H21.715V11.0563H24.6775L24.6787 8.955Z" fill="currentColor" />
  </svg>
);

export default ServiceRoomIcon;
